interface GeofenceConfig {
  center: {
    latitude: number;
    longitude: number;
  };
  radius: number; // in meters
}

class GeofenceService {
  private defaultConfig: GeofenceConfig = {
    center: {
      latitude: 12.9716, // Default to Bangalore coordinates
      longitude: 77.5946,
    },
    radius: 100, // 100 meters radius
  };

  private config: GeofenceConfig;

  constructor() {
    // Load config from localStorage or use default
    const savedConfig = localStorage.getItem('geofence_config');
    this.config = savedConfig ? JSON.parse(savedConfig) : this.defaultConfig;
  }

  async isInDesignatedArea(location: GeolocationPosition): Promise<boolean> {
    try {
      const distance = this.calculateDistance(
        location.coords.latitude,
        location.coords.longitude,
        this.config.center.latitude,
        this.config.center.longitude
      );

      console.log(`Distance from center: ${distance}m, Radius: ${this.config.radius}m`);
      return distance <= this.config.radius;
    } catch (error) {
      console.error('Error checking geofence:', error);
      return false;
    }
  }

  private calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371e3; // Earth's radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }

  updateGeofenceConfig(newConfig: Partial<GeofenceConfig>): void {
    this.config = { ...this.config, ...newConfig };
    localStorage.setItem('geofence_config', JSON.stringify(this.config));
    console.log('Geofence config updated:', this.config);
  }

  getGeofenceConfig(): GeofenceConfig {
    return { ...this.config };
  }

  resetToDefault(): void {
    this.config = { ...this.defaultConfig };
    localStorage.setItem('geofence_config', JSON.stringify(this.config));
    console.log('Geofence config reset to default');
  }
}

export const geofenceService = new GeofenceService(); 